import {keyframes} from 'styled-components';

const showAnimation = keyframes`
0% {
    transform: translateY(100vh);
    opacity: 0;
}

100% {
    transform: translateY(0vh);
    opacity: 1;
}
`;

const closeAnimation = keyframes`
0% {
    transform: translateY(0vh);
    opacity: 1;
}

100% {
    transform: translateY(100vh);
    opacity: 0;
}
`;

const benefitBoxAnimation = keyframes`
0% {
    transform: rotate(365deg);
    opacity: 0;
}

50% {
    transform: rotate(365deg);
    opacity: 0;
}

83% {
    transform: rotate(360deg);
}

100% {
    opacity: 1;
}
`;

const benefitBoxAnimation2 = keyframes`
0% {
    transform: translateY(-10px);
    opacity: 0;
}

50% {
    transform: translateY(-10px);
    opacity: 0;
}

70% {
    transform: translateY(5px);
}

80% {
    transform: translateY(0px);
}

90% {
    transform: translateY(3px);
}

100% {
    transform: translateY(0px);
    opacity: 1;
}
`;

const benefitBoxAnimation3 = keyframes`
0% {
    transform: rotate(368deg);
    opacity: 0;
}

50% {
    transform: rotate(368deg);
    opacity: 0;
}

67% {
    transform: rotate(362deg);
}

83% {
    transform: rotate(360deg);
}

100% {
    transform: rotate(362deg);
    opacity: 1;
}
`;

const benefitBoxAnimation4 = keyframes`
0% {
    transform: rotate(366deg);
    opacity: 0;
}

50% {
    transform: rotate(366deg);
    opacity: 0;
}

67% {
    transform: rotate(359deg);
}

83% {
    transform: rotate(358deg);
}

100% {
    transform: rotate(359deg);
    opacity: 1;
}
`;

const stevenAnimation = keyframes`
0% {
    transform: translateX(30px);
    opacity: 0;
}

100% {
    transform: translateX(0px);
    opacity: 1;
}
`;

const bmoAnimation = keyframes`
0% {
    transform: translate(-10px, 10px);
    opacity: 0;
}

100% {
    transform: translate(0px, 0px);
    opacity: 1;
}
`;

export {
    showAnimation,
    closeAnimation,
    benefitBoxAnimation,
    benefitBoxAnimation2,
    benefitBoxAnimation3,
    benefitBoxAnimation4,
    stevenAnimation,
    bmoAnimation,
};
